"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeWhitelabel = void 0;
const tslib_1 = require("tslib");
const estacio_logo_negative_png_1 = tslib_1.__importDefault(require("../assets/images/estacio-logo-negative.png"));
const estacio_logo_positive_png_1 = tslib_1.__importDefault(require("../assets/images/estacio-logo-positive.png"));
const estacio_logomarca_negative_png_1 = tslib_1.__importDefault(require("../assets/images/estacio-logomarca-negative.png"));
const estacio_logomarca_positive_png_1 = tslib_1.__importDefault(require("../assets/images/estacio-logomarca-positive.png"));
const grid_1 = require("./grid");
const themeWhitelabel = (temaLift) => {
    const breakpoints = (0, grid_1.Breakpoints)();
    const offset = (0, grid_1.Offset)();
    const mediaQuery = (0, grid_1.MediaQuery)();
    const temaBase = Object.assign(Object.assign(Object.assign(Object.assign({ name: 'whitelabel' }, breakpoints), offset), mediaQuery), { 
        // Primary Colors
        p001: '#0FBDD9', p002: '#141D27', p003: '#516174', 
        // Secundary Colors
        s001: '#E2E419', s002: '#A6CE39', s003: '#006DA3', s004: '#4E819F', s005: '#3A5181', s006: '#034168', 
        // Secondary Contrast
        sc001: '#141D27', sc002: '#E2E419', 
        // Actions Colors
        action001: '#3EC9E0', action002: '#6CD5E6', action003: '#9BE1ED', action004: '#C9EDF3', 
        // Greys Colors
        grey001: '#939FAD', grey002: '#ACB7C4', grey003: '#CAD3DE', grey004: '#E4E9EF', grey005: '#F8F9FA', 
        // Feedback Colors
        success: '#61B165', successLight: '#DFF7EA', error: '#EF5350', errorLight: '#FEE6DC', warning: '#F4BD00', warningLight: '#FFF5D3', 
        // Extras Colors
        pink: '#FF5790', pinkLight: '#FFE3ED', purple: '#D156D3', purpleLight: '#FBE3FF', violet: '#8E56E3', violetLight: '#EEE3FF', blue: '#5A9CFF', blueLight: '#E3F3FF', teal: '#26A69A', tealLight: '#E3FFFC', orange: '#FF8743', orangeLight: '#FFEDE3', white: '#FFFFFF', black: '#000000', 
        // Logos
        logomarcaPositive: estacio_logomarca_positive_png_1.default, logoPositive: estacio_logo_positive_png_1.default, logomarcaNegative: estacio_logomarca_negative_png_1.default, logoNegative: estacio_logo_negative_png_1.default, 
        // Img Login
        imgLoginTitleAluno: '', imgLoginTitleProfessor: 'Foto de Christina Morillo no Pexels' });
    // Combina o tema base com todos os tokens do Lift
    return Object.assign(Object.assign({}, temaBase), temaLift);
};
exports.themeWhitelabel = themeWhitelabel;
